import React, { useRef, useEffect } from "react";
import imageSrc4 from "../../assets/images/big-weso-logo.svg";

// Define the scroll range over which the logo will be fully visible.
// For example, 0.4 means 40% of the viewport height.
const FADE_IN_END_POINT = 0.35; // Logo is fully visible when it crosses this point
const FADE_OUT_START_POINT = 0.75; // Logo starts fading out at this point

export const BigLogo: React.FC = () => {
  const logoRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    if (!logoRef.current) return;

    const element = logoRef.current;

    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const rect = element.getBoundingClientRect();

      // Calculate the logo's center position relative to the viewport height (0 to windowHeight)
      const elementCenter = rect.top + rect.height / 2;

      // Normalize position: 0 when element is at the bottom, 1 when element is at the top
      // This is the primary value we use to determine scroll depth within the viewport
      const normalizedPosition = elementCenter / windowHeight;

      let opacity = 1;

      if (normalizedPosition > FADE_OUT_START_POINT) {
        // --- FADE OUT Logic (Logo moving down and off-screen) ---
        // Progress goes from 0 (at FADE_OUT_START_POINT) to 1 (at bottom of screen)
        const progress = (normalizedPosition - FADE_OUT_START_POINT) / (1 - FADE_OUT_START_POINT);
        opacity = 1 - progress;

      } else if (normalizedPosition < FADE_IN_END_POINT) {
        // --- FADE IN Logic (Logo entering from top) ---
        // Progress goes from 0 (at top of screen) to 1 (at FADE_IN_END_POINT)
        const progress = 1 - (normalizedPosition / FADE_IN_END_POINT);
        opacity = 1 - progress;
      }

      // Clamp opacity between 0 and 1
      opacity = Math.max(0, Math.min(1, opacity));

      // Apply the opacity to the element
      element.style.opacity = opacity.toString();

    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Set initial state

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="banner neumorphic-container rounded-0 p-5 mb-3 d-flex justify-content-center
    align-items-center logo-section overflow-hidden">
      <img
        ref={logoRef}
        src={imageSrc4}
        id="weso-logo"
        className="img-fluid absolute-parallax-logo"
        alt="WESO Logo"
      />
    </section>
  );
}
export default BigLogo;
